import React, { useEffect } from "react";

const Level3Division = () => {
  useEffect(() => {
    showQuestion();
  }, []);

  const questions = [
    { q: "127 ÷ 6", a: 21, r: 1, hint: "6 × 20 = 120, what's left?" },
    { q: "143 ÷ 4", a: 35, r: 3, hint: "120 ÷ 4 = 30, 23 ÷ 4 = ?" },
    { q: "238 ÷ 5", a: 47, r: 3, hint: "Try 200 ÷ 5 + 30 ÷ 5 + ?" },
    { q: "319 ÷ 7", a: 45, r: 4, hint: "Use 280 ÷ 7 = 40, then go from there" },
    { q: "411 ÷ 8", a: 51, r: 3, hint: "Try 400 ÷ 8 = 50, 11 ÷ 8 = ?" },
    { q: "218 ÷ 5", a: 43, r: 3, hint: "Divide 200 ÷ 5, then the rest" },
    { q: "357 ÷ 7", a: 51, r: 0, hint: "Perfect division!" },
    { q: "456 ÷ 9", a: 50, r: 6, hint: "450 ÷ 9 = 50" },
    { q: "789 ÷ 8", a: 98, r: 6, hint: "Try 800 ÷ 8 = 100 and adjust" },
  ];

  let shuffled = questions.sort(() => 0.5 - Math.random());
  let current = 0;

  function showQuestion() {
    const q = shuffled[current];
    document.getElementById("question").innerText = q.q;
    document.getElementById("hint").innerText = "💡 Hint: " + q.hint;
    document.getElementById("answer").value = "";
    document.getElementById("feedback").innerText = "";
  }

  function checkAnswer() {
    const userInput = document.getElementById("answer").value.trim().toLowerCase();
    const [userQuotient, userRemainder] = userInput.split("r").map((v) => parseInt(v.trim()));
    const correct = shuffled[current];
    const feedback = document.getElementById("feedback");
    const correctSound = document.getElementById("correctSound");
    const wrongSound = document.getElementById("wrongSound");

    if (userQuotient === correct.a && userRemainder === correct.r) {
      feedback.innerText = "✅ Correct! Great job!";
      feedback.className = "feedback correct";
      correctSound.play();

      current++;
      if (current < shuffled.length) {
        setTimeout(showQuestion, 1500);
      } else {
        document.querySelector(".container").innerHTML = `
          <div class="end-message">🎉 Woohoo! You're a division with remainders master!</div>
        `;
      }
    } else {
      feedback.innerText = "❌ Try again! Use format like: 45 r3";
      feedback.className = "feedback incorrect";
      wrongSound.play();
    }
  }

  return (
    <div
      style={{
        fontFamily: "'Comic Sans MS', cursive",
        background: "linear-gradient(to right, #fff8dc, #ffe0b2)",
        textAlign: "center",
        padding: "2rem",
        minHeight: "100vh",
        margin: 0,
        overflowX: "hidden",
      }}
    >
      <div
        className="container"
        style={{
          background: "#fff3b0",
          padding: "2rem",
          borderRadius: "20px",
          maxWidth: "600px",
          margin: "2rem auto",
          boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)",
          transition: "all 0.3s ease",
        }}
      >
        <h1
          style={{
            fontSize: "2rem",
            color: "#d17b0f",
            marginBottom: "1rem",
          }}
        >
          🧠 Level 3: Division with Remainders
        </h1>

        <div
          className="question"
          id="question"
          style={{
            fontSize: "1.6rem",
            marginBottom: "1rem",
            color: "#333",
          }}
        ></div>
        <div
          className="hint"
          id="hint"
          style={{
            fontSize: "1rem",
            color: "#666",
            marginBottom: "1rem",
          }}
        ></div>

        <div
  style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "1rem",
    marginBottom: "1rem",
  }}
>
  <input
    type="text"
    id="answer"
    placeholder="e.g., 35 r3"
    style={{
      padding: "0.5rem",
      fontSize: "1.3rem",
      borderRadius: "12px",
      border: "2px solid #ffb300",
      textAlign: "center",
      width: "150px",
    }}
  />

  <button
    onClick={checkAnswer}
    style={{
      padding: "0.7rem 1.5rem",
      fontSize: "1.1rem",
      backgroundColor: "#ffca28",
      color: "#333",
      border: "none",
      borderRadius: "12px",
      cursor: "pointer",
      transition: "background 0.3s ease",
    }}
    onMouseOver={(e) => (e.target.style.backgroundColor = "#ffc107")}
    onMouseOut={(e) => (e.target.style.backgroundColor = "#ffca28")}
  >
    Submit
  </button>
</div>


        <div
          className="feedback"
          id="feedback"
          style={{
            marginTop: "1.2rem",
            fontSize: "1.3rem",
            fontWeight: "bold",
            transition: "all 0.4s ease",
          }}
        ></div>
      </div>

      <audio
        id="correctSound"
        src="https://www.soundjay.com/buttons/sounds/button-3.mp3"
        preload="auto"
      ></audio>
      <audio
        id="wrongSound"
        src="https://www.soundjay.com/buttons/sounds/button-10.mp3"
        preload="auto"
      ></audio>

      <style>{`
        .correct {
          color: green;
          animation: pop 0.4s ease;
        }
        .incorrect {
          color: red;
          animation: shake 0.4s ease;
        }
        .end-message {
          font-size: 1.5rem;
          margin-top: 2rem;
          color: #4caf50;
          animation: pop 1s infinite;
        }
        @keyframes pop {
          0% { transform: scale(1); }
          50% { transform: scale(1.2); }
          100% { transform: scale(1); }
        }
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          25% { transform: translateX(-5px); }
          75% { transform: translateX(5px); }
        }
      `}</style>
    </div>
  );
};

export default Level3Division;
